import styled from '@emotion/styled';

import {ReactComponent as LoansSVG} from '../../assets/icons/ic_loans.svg';

export const IconLoans = styled(LoansSVG)`
  width: ${({theme}) => theme.icon.size.lg};
  height: ${({theme}) => theme.icon.size.lg};
  fill: ${({theme}) => theme.color.neutral.grey_900};
`;
